import apiClient from './apiClient';

export const getAttendance = async (date) => {
  const url = date ? `attendance?date=${date}` : 'attendance';
  const response = await apiClient.get(url);
  return response.data;
};

export const createAttendance = async (record) => {
  const response = await apiClient.post('attendance', record);
  return response.data;
};
